module.exports = __webpack_public_path__ + "img/new_handmade.40df2750.svg";